var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBrizTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00195312,
    width: 118,
    height: 118,
    rx: 23.6,
    fill: "#1C1C1C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7472 68.4214L63.6125 59.663L35.3984 43.332V93.5142C35.3984 100.243 42.6658 104.449 48.4811 101.083L63.6125 92.325L78.7472 83.5666C84.5625 80.2006 84.5625 71.7874 78.7472 68.4214ZM65.9509 78.7825L58.3528 83.1805L50.7548 87.5785C48.6141 88.8189 45.9348 87.2675 45.9348 84.7866V61.6177L58.3528 68.8041L65.9509 73.2021C68.0915 74.4426 68.0915 77.542 65.9509 78.7825Z",
    fill: "#FC6621"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7472 53.1413L72.24 56.8962L35.3984 35.5698V19.4498C35.3984 16.5945 38.4902 14.8091 40.9649 16.2367L63.6125 29.3106L78.7472 38.0435C84.5625 41.3997 84.5625 49.7851 78.7472 53.1413Z",
    fill: "#00B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBrizTv);
export default __webpack_public_path__ + "static/media/logoBrizTV.ad4cd06e6169788cde858008f2f79b83.svg";
export { ForwardRef as ReactComponent };